export default "__VITE_ASSET__RTpjoMNY__"